import { css } from 'styled-components';
import { OnlineThemeType } from '../../themes/online';

export const Sidebar = ({ theme }: { theme: OnlineThemeType }) => {
  return css`
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-width: 272px;
    width: 100%;
    height: 100%;
    border-right: 1px solid ${theme.colors.brightBlue};
    padding-top: 50px;
    position: relative;
    overflow-x: hidden;
    flex-shrink: 0;
    min-height: calc(100vh - 80px);

    @media (${theme.device.max.laptopM}) {
      max-width: 252px;
    }

    @media (${theme.device.max.laptop}) {
      max-width: 214px;
    }

    --padding-sides: ${theme.spacing.larger}px;
    font-family: 'Poppins';
    & .title {
      padding-inline: var(--padding-sides);
      text-align: left;
      margin-bottom: 5px;
      font-family: 'Poppins';
      box-sizing: border-box;
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 27px;
      color: ${theme.colors.primaryBackground};
    }

    & .sidebar-item {
      box-sizing: border-box;
      font-weight: 600;
      font-size: 14px;
    }
    & .sidebar-item-container {
      list-style-type: none;
      color: ${theme.colors.tintDeepBlue};
      border-left: solid 5px transparent;
      padding-inline: var(--padding-sides);
      padding-left: 26px;
      padding-block: 16px;
      font-size: 14px;
      cursor: pointer;
      font-family: 'Poppins';
      box-sizing: border-box;
      font-weight: 400;
    }

    & .sidebar-item-container.selected {
      border-left: solid 5px ${theme.colors.primaryBright};
      color: ${theme.colors.primaryBright};
      line-height: 21px;
    }

    @media ${theme.device.max.tabletS} {
      width: 100%;
      border-right: none;
      padding: 0px;
      min-height: auto;
      max-width: none;
      height: auto;
      position: fixed;
      z-index: 2;
      animation: closeSidebar 60ms linear forwards;

      & .title {
        font-size: 16px;
        display: none;
      }

      & .nav-items {
        z-index: 1;
        background-color: ${theme.colors.white};
        transition: transform 200ms ease-in-out;
        transform: rotateX(-90deg);
        transform-origin: top center;
      }

      &.open {
        height: auto;
        animation: none;

        & .title {
          display: block;
        }
        & .nav-items {
          transform: rotateX(0deg);
          transform-origin: top center;
        }
      }

      @keyframes closeSidebar {
        99% {
          height: auto;
        }

        100% {
          height: 0;
        }
      }

      & .sidebar-item {
        display: flex;
      }

      & .sidebar-item-container {
        padding-inline: 16px;
        border-left: none;
        color: ${theme.colors.placeholder};
        font-size: 16px;
      }

      & .sidebar-item-container.selected {
        border-left: none;
        border-radius: 4px;
        background-color: ${theme.colors.brightBlue};
        color: ${theme.colors.placeholder};
        font-weight: 600;
      }

      & .sidebar-item-icon {
        margin-inline-start: auto;
      }
    }
  `;
};
